import { en } from './en';
import { sv } from './sv';

export type LocaleMessages = Record<keyof typeof sv, string>;

export type SupportedLocale = 'sv' | 'en';

export const locales: Record<SupportedLocale, LocaleMessages> = {
  en,
  sv,
} as const;
